export { type AppWordMeaningCard, appWordMeaningCardTable } from "#app-word-meaning-card-table";
